/**
 * File: crmSettingsService.ts
 * Path: apps/admin/src/shared/services/crmSettingsService.ts
 * Description: Reads and saves crmSettings/main: stale-lead limits, the
 * daily outreach goal and hourly rates. Missing or odd values read as the defaults.
 */

import { db, FIRESTORE_COLLECTIONS, FirestoreService } from "@idk/config";
import { toCrmSettings, type CrmSettings } from "../utils/todayListUtils";
import { doc, serverTimestamp, setDoc, type Firestore } from "firebase/firestore";

const SETTINGS_ID = "main";

export const createCrmSettingsRepo = (getDb: () => Firestore) => ({
  get: async (): Promise<CrmSettings> => {
    const row = await FirestoreService.getById<Record<string, unknown> & { id: string }>(
      FIRESTORE_COLLECTIONS.crmSettings,
      SETTINGS_ID,
    );
    return toCrmSettings(row);
  },
  save: async (settings: CrmSettings): Promise<void> => {
    await setDoc(doc(getDb(), FIRESTORE_COLLECTIONS.crmSettings, SETTINGS_ID), {
      staleDays: settings.staleDays,
      dailyOutreachGoal: settings.dailyOutreachGoal,
      defaultHourlyRateCents: settings.defaultHourlyRateCents,
      rates: settings.rates,
      updatedAt: serverTimestamp(),
    });
  },
});

export const crmSettingsRepo = createCrmSettingsRepo(() => db);
